import { render, staticRenderFns } from "./cardgrid4.vue?vue&type=template&id=3f3c1651&scoped=true"
import script from "./cardgrid4.vue?vue&type=script&lang=js"
export * from "./cardgrid4.vue?vue&type=script&lang=js"
import style0 from "./cardgrid4.vue?vue&type=style&index=0&id=3f3c1651&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3c1651",
  null
  
)

export default component.exports